/*************************************************************************
 * ADOBE CONFIDENTIAL
 * ___________________
 *
 *  Copyright 2019 Adobe
 *  All Rights Reserved.
 *
 * NOTICE:  All information contained herein is, and remains
 * the property of Adobe and its suppliers, if any. The intellectual
 * and technical concepts contained herein are proprietary to Adobe
 * and its suppliers and are protected by all applicable intellectual
 * property laws, including trade secret and copyright laws.
 * Dissemination of this information or reproduction of this material
 * is strictly forbidden unless prior written permission is obtained
 * from Adobe.
 **************************************************************************/
import AdobeAdvertisingCloud from '@exc/brand-icons/AdvertisingCloud';
import AdobeAdvertisingCloudColor from '@exc/brand-icons/AdvertisingCloudColor';
import AdobeAnalytics from '@exc/brand-icons/Analytics';
import AdobeAnalyticsColor from '@exc/brand-icons/AnalyticsColor';
import AdobeAudienceManager from '@exc/brand-icons/AudienceManager';
import AdobeAudienceManagerColor from '@exc/brand-icons/AudienceManagerColor';
import AdobeCampaign from '@exc/brand-icons/Campaign';
import AdobeCampaignColor from '@exc/brand-icons/CampaignColor';
import AdobeExperienceCloudColor from '@exc/brand-icons/ExperienceCloudColor';
import AdobeExperienceManager from '@exc/brand-icons/ExperienceManager';
import AdobeExperienceManagerColor from '@exc/brand-icons/ExperienceManagerColor';
import AdobeExperiencePlatformColor from '@exc/brand-icons/ExperiencePlatformColor';
import AdobePrimetime from '@exc/brand-icons/Primetime';
import AdobePrimetimeColor from '@exc/brand-icons/PrimetimeColor';
import AdobeTarget from '@exc/brand-icons/Target';
import AdobeTargetColor from '@exc/brand-icons/TargetColor';
import Icon from '@react/react-spectrum/Icon';
import MagentoCommerce from '@exc/brand-icons/Magento';
import MagentoCommerceColor from '@exc/brand-icons/MagentoColor';
import PropTypes from 'prop-types';
import React from 'react';

const Icons = {
  AdobeAdvertisingCloud,
  AdobeAdvertisingCloudColor,
  AdobeAnalytics,
  AdobeAnalyticsColor,
  AdobeAudienceManager,
  AdobeAudienceManagerColor,
  AdobeCampaign,
  AdobeCampaignColor,
  AdobeExperienceCloudColor,
  AdobeExperienceManager,
  AdobeExperienceManagerColor,
  AdobeExperiencePlatformColor,
  AdobePrimetime,
  AdobePrimetimeColor,
  AdobeTarget,
  AdobeTargetColor,
  MagentoCommerce,
  MagentoCommerceColor
};

const ColorIcon = ({enabled, iconName, iconSize}) => {
  let IconComponent = Icons.AdobeExperienceCloudColor;

  if (iconName === 'AdobeExperienceCloud' || iconName === 'AdobeExperiencePlatform') {
    IconComponent = Icons[`${iconName}Color`];
  } else if (iconName in Icons) {
    IconComponent = Icons[enabled ? `${iconName}Color` : iconName];
  }
  return <Icon size={iconSize}><IconComponent /></Icon>;
};

ColorIcon.propTypes = {
  enabled: PropTypes.bool,
  iconName: PropTypes.string,
  iconSize: PropTypes.string
};

ColorIcon.defaultProps = {
  enabled: true,
  iconSize: 'XL'
};

export default React.memo(ColorIcon);
